class PredictiveSearch extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input[type="search"]');
		this.predictiveSearchResults = document.querySelector('#predictive-search');
		this.input.addEventListener(
			'input',
			this.debounce(event => {
				this.onChange(event);
			}, 300).bind(this)
		);
	}
	onChange() {
		const searchTerm = this.input.value.trim();
		if (!searchTerm.length) {
			this.close();
			const resultsPresets = document.querySelector('.drawer-search__presets');
			if (resultsPresets) resultsPresets.style.display = 'grid';
			return;
		}
		this.getSearchResults(searchTerm);
	}
	getSearchResults(searchTerm) {
		fetch(window.Shopify.routes.root + `search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=10&section_id=predictive-search`)
			.then(response => {
				if (!response.ok) {
					let error = new Error(response.status);
					this.close();
					throw error;
				}
				return response.text();
			})
			.then(text => {
				const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
				this.predictiveSearchResults.innerHTML = resultsMarkup;
				this.open();
				window.initResultsSlider();
				const resultsPresets = document.querySelector('.drawer-search__presets');
				if (resultsPresets) resultsPresets.style.display = 'none';
				// window.initImageLoad();
				// window.loadPowerReviews();
				// window.initProductCardButtons();
				let predictiveSubmit = document.getElementById('searchbutton');
				let predictiveField = document.getElementById('drawer-search-input');
				if (predictiveSubmit && predictiveField)
					predictiveSubmit.addEventListener('click', e => {
						e.preventDefault();
						let searchTerm = predictiveField.value;
						let searchURL = window.Shopify.routes.root + 'search/?q=' + searchTerm + '&type=product';
						window.location = searchURL;
					});

				// const displayHeight = () => {
				// 	let windowHeight = Number(window.innerHeight);
				// 	let siteHeader = document.querySelector('.wrap--header');
				// 	let siteHeaderHeight = Number(siteHeader.offsetHeight);
				// 	let searchInput = document.querySelector('.wrap--search');
				// 	let searchInputHeight = Number(searchInput.offsetHeight);
				// 	let searchResultsHeight = windowHeight - siteHeaderHeight - searchInputHeight + 'px';
				// 	let searchResultsDisplay = document.getElementById('predictive-search');
				// 	searchResultsDisplay.style.maxHeight = searchResultsHeight;
				// 	if (window.innerWidth <= 768) searchResultsDisplay.style.minHeight = searchResultsHeight;
				// };
				// displayHeight();
				// window.addEventListener('resize', () => {
				// 	displayHeight();
				// });
			})
			.catch(error => {
				this.close();
				throw error;
			});
	}
	open() {
		this.predictiveSearchResults.style.display = 'block';
	}
	close() {
		this.predictiveSearchResults.style.display = 'none';
	}
	debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}
}
customElements.define('predictive-search', PredictiveSearch);
